import { render, staticRenderFns } from "./ViewImpressum.vue?vue&type=template&id=4b6f7b5f&scoped=true&"
import script from "./ViewImpressum.vue?vue&type=script&lang=js&"
export * from "./ViewImpressum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f7b5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
